type ResponseChunk = {
  Candidates?:
    | [
        {
          Index: number;
          Content?: { Role: 'model'; Parts?: string[] };
          FinishReason: number;
          SafetyRatings: never[];
          FinishMessage: string;
          CitationMetadata: null;
        },
      ]
    | [];
  PromptFeedback: null;
  UsageMetadata: {
    PromptTokenCount: number;
    CandidatesTokenCount: number;
    TotalTokenCount: number;
  };
};

type ErrorChunk = {
  error: string;
};

const isErrorChunk = (data: unknown): data is ErrorChunk =>
  typeof data === 'object' && data !== null && 'error' in data;

export const parseCypherChunk = (line: string): string => {
  let data: ResponseChunk | ErrorChunk | undefined;

  try {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    data = JSON.parse(line) as ResponseChunk | ErrorChunk;
  } catch (e) {
    throw new Error('Error parsing response');
  }

  if (isErrorChunk(data)) {
    throw new Error(data.error);
  }

  if (!data.Candidates || data.Candidates.length === 0) {
    return '';
  }

  const [candidate] = data.Candidates;
  const [cypherChunk] = candidate.Content?.Parts ?? [undefined];

  return cypherChunk ?? '';
};
